import { isMobileScreen } from 'common/utilities';
import { useAppSelector } from 'store';

export function useFullScreenCard(): boolean {
  const { screenSize } = useAppSelector((state) => state.layout);
  const isFullScreenCard = isMobileScreen(screenSize);
  return isFullScreenCard;
}
